<!--
 * @Description: 账单列表
 * @Author: ChenXueLin
 * @Date: 2021-09-22 15:17:20
 * @LastEditTime: 2022-07-15 16:45:52
 * @LastEditors: ChenXueLin
-->
<template>
  <div class="content-view-wrapper pd-10">
    <div class="content-view section-wrapper" ref="sectionWrapper">
      <!-- <tab-pane :tabList="tabList" @handleTab="handleTab"></tab-pane> -->
      <accountCheck v-if="paneType == '1'"></accountCheck>
      <receivable v-if="paneType == '2'"></receivable>
      <billFlush v-if="paneType == '3'"></billFlush>
      <bailApply v-if="paneType == '4'"></bailApply>
    </div>
  </div>
</template>

<script>
// import base from "@/mixins/base";
// import listPage from "@/mixins/list-page";
// import listPageReszie from "@/mixins/list-page-resize";
// import tabPane from "@/components/tabPane";
import accountCheck from "./components/accountCheck.vue";
import receivable from "./components/receivable.vue";
import billFlush from "./components/billFlush.vue";
import bailApply from "./components/bailApply.vue";
export default {
  name: "billManage",
  data() {
    return {
      editVisible: false,
      paneType: "1", //1列表页，2配置页
      tabList: [
        {
          label: "对账单",
          name: "1"
        },
        {
          label: "应收",
          name: "2"
        },
        {
          label: "账单齐平",
          name: "3"
        },
        {
          label: "质保金申请",
          name: "4"
        }
      ],
      editForm: {}
    };
  },
  //   mixins: [base, listPage, listPageReszie],

  computed: {},
  components: {
    // tabPane,
    accountCheck,
    receivable,
    billFlush,
    bailApply
  },
  mounted() {},

  methods: {
    toDetail() {
      this.routerPush({
        name: "taskListManage/detail",
        params: {
          refresh: true
        }
      });
    },
    //创建任务单
    createTask() {
      this.routerPush({
        name: "taskListManage/add",
        params: {
          refresh: true
        }
      });
    },
    handleTab(val) {
      console.log(val);
      this.paneType = val;
    },
    handleClose() {}
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 20px;
  padding-top: 0px;
  box-sizing: border-box;
}
.list-box {
  .config {
    display: flex;
    align-items: center;
    margin-top: 40px;
    .til1 {
      color: #545456;
      width: 100px;
      text-align: right;
      margin-right: 50px;
    }
    .til2 {
      width: 250px;
      color: #8b8b8b;
    }
  }
}
.edit-dialog {
  padding: 30px;
  box-sizing: border-box;
}
</style>
